import BaseRepository from "./base-repository";

class SeasonRepository extends BaseRepository {
    constructor(table, memoryCache) {
        super(table, memoryCache);
    }

    getBySeasonId(seasonId) {
        return this.table.where({ seasonId: seasonId }).first();
    }
}

export default SeasonRepository;
